export enum ChartFormat {
  FULL,
  VERTICAL,
  HORIZONTAL,
}
